
import { defineComponent } from 'vue'
import { iCalendar, iDomain } from './CalendarManagement'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import moment from 'moment'
import calendarManagementDescriptor from './CalendarManagementDescriptor.json'
import CalendarManagementDialog from './CalendarManagementDialog/CalendarManagementDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import KnFabButton from '@/components/UI/KnFabButton.vue'
import KnOverlaySpinnerPanel from '@/components/UI/KnOverlaySpinnerPanel.vue'

export default defineComponent({
    name: 'calendar-management',
    components: { CalendarManagementDialog, Column, DataTable, KnFabButton, KnOverlaySpinnerPanel },
    data() {
        return {
            calendarManagementDescriptor,
            calendars: [] as iCalendar[],
            domains: [] as iDomain[],
            filters: { global: [filterDefault] },
            selectedCalendar: null as iCalendar | null,
            calendarDialogVisible: false,
            loading: false
        }
    },
    computed: {
        canManageCalendar(): boolean {
            return (this.$store.state as any).user.functionalities.includes('ManageCalendar')
        }
    },
    async created() {
        await this.loadCalendars()
        await this.loadDomains()
    },
    methods: {
        async loadCalendars() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `calendar/getCalendarList`).then((response: AxiosResponse<any>) => (this.calendars = response.data))
            this.loading = false
        },
        async loadDomains() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `calendar/getDomains`).then((response: AxiosResponse<any>) => (this.domains = response.data))
            this.loading = false
        },
        showForm(event: any = null) {
            this.selectedCalendar = event ? event.data : this.createNewCalendar()
            this.calendarDialogVisible = true
        },
        getFormattedDate(date: number) {
            const tempDate = moment(date).format('DD/MM/YYYY')
            return formatDate(tempDate, '', 'DD/MM/YYYY')
        },
        deleteCalendarConfirm(calendar: iCalendar) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteCalendar(calendar)
            })
        },
        async deleteCalendar(calendar: iCalendar) {
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `calendar/${calendar.calendarId}/deleteCalendar`)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    this.removeCalendar(calendar)
                })
                .catch(() => {})
        },
        removeCalendar(calendar: iCalendar) {
            const index = this.calendars.findIndex((tempCalendar: iCalendar) => tempCalendar.calendarId === calendar.calendarId)
            if (index !== -1) this.calendars.splice(index, 1)
        },
        createNewCalendar() {
            return {
                realDateGenerated: [],
                splittedCalendar: [],
                calStartDay: null,
                calEndDay: null,
                calendar: '',
                calType: ''
            } as iCalendar
        },
        closeCalendarDialog() {
            this.selectedCalendar = null
            this.calendarDialogVisible = false
        },
        onCalendarSaved() {
            this.loadCalendars()
        }
    }
})
